import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=130d1baa&scoped=true"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=130d1baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d1baa",
  null
  
)

export default component.exports